import { RESOURCES_BASE } from './constants'

export interface InsidePage {
  src: string
  alt: string
}

/** Five interior pages of the product (4:5). */
export const insidePages: InsidePage[] = [
  { src: RESOURCES_BASE + '1793845680452_p1-8a4e3621.jpg', alt: 'Module 01 · Codes de ratés et capteur vilebrequin' },
  { src: RESOURCES_BASE + '1793845686539_p2-9e387096.jpg', alt: 'Module 02 · Synchronisation CKP / CMP' },
  { src: RESOURCES_BASE + '1793845693444_p3-822ce6d2.jpg', alt: 'Module 03 · Diagnostic du bus CAN' },
  { src: RESOURCES_BASE + '1793845699633_p4-e5f1963d.jpg', alt: 'Module 05 · Direction assistée électrique' },
  { src: RESOURCES_BASE + '1793845705241_p5-2e374934.jpg', alt: 'Module 06 · Cas pratique : ratés sur un cylindre' },
]
